import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PermissionsState } from '@anduin/auth';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { LoadableStatus } from '../utils';

// TODO :: This is in the wrong place, but is not exported by shared
@Injectable({
  providedIn: 'root',
})
export class ReportingOnlyGuard {
  constructor(
    private readonly store: Store,
    private readonly router: Router,
  ) {}

  /**
   * Once permissions are loaded, if user only has access to analytics, route them to /reports/r.
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.select(PermissionsState.getStatus).pipe(
      filter((status) => [LoadableStatus.LOADED, LoadableStatus.ERROR].includes(status)),
      switchMap(() =>
        this.store.select(PermissionsState.reportingOnly).pipe(
          map((analyticsOnly) => {
            if (analyticsOnly) {
              return this.router.parseUrl('/reports');
            } else {
              return true;
            }
          }),
        ),
      ),
    );
  }
}
